var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreyUserVerified = function SvgGreyUserVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E89A1",
    fillRule: "evenodd",
    d: "M5.25 4.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M7.5.665a3.583 3.583 0 0 0-2.183 6.426c-3.006.647-5.31 3.197-5.31 6.282v.65a.667.667 0 0 0 1.334 0v-.65c0-2.768 2.429-5.108 5.475-5.108H8.2c1.138 0 2.197.33 3.066.886a.667.667 0 0 0 .72-1.122 7 7 0 0 0-2.3-.941A3.583 3.583 0 0 0 7.5.666M14.722 9.487c.26.26.26.682-.001.943l-4.892 4.883a.667.667 0 0 1-.942 0L6.945 13.37a.667.667 0 0 1 .943-.943l1.47 1.47 4.421-4.412c.26-.26.683-.26.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgGreyUserVerified;